import { render, staticRenderFns } from "./ChargeCategoryManagement.vue?vue&type=template&id=5dd3c7cc&scoped=true"
import script from "./ChargeCategoryManagement.vue?vue&type=script&lang=js"
export * from "./ChargeCategoryManagement.vue?vue&type=script&lang=js"
import style0 from "./ChargeCategoryManagement.vue?vue&type=style&index=0&id=5dd3c7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd3c7cc",
  null
  
)

export default component.exports